module.exports = __webpack_public_path__ + "media/finish_succes.8b0b11e3.flac";